export const VIOLATION_TYPE_OPTION = [
  "name",
  "description",
  "howToFixDescription",
  "Subdivision",
  "reportedByUser",
];

export const VIOLATION_OPTION = ["description"];
